import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Axios from "axios";
import { confirmAlert } from "react-confirm-alert";
import AkkhorLayout from "../layout/akkhor";
import Spinner from "../component/Spinner";
import { URL_LIST_ALL } from "../configs/api";

/**
 * CÀI ĐẶT NGÀY CHỐT CÔNG THEO CÔNG TY
 *
 * Mỗi công ty có thể có ngày chốt công riêng (company.chotcong). Để trống = dùng
 * ngày chốt chung ở "Cài đặt nhân sự" (hrsettings.chotcong, hiện là 26).
 *
 * Cách tra dội từ trên xuống giống ca làm việc: công ty -> mặc định chung.
 * Backend: App\Services\KyCong.
 */
export default function CaiDatNgayChotCong() {
    const { user } = useSelector((state) => state.auth);
    const [danhSach, setDanhSach] = useState([]);
    const [ngayChotChung, setNgayChotChung] = useState(26);
    const [giaTri, setGiaTri] = useState({});
    const [dangLuu, setDangLuu] = useState(null);
    const [dangTai, setDangTai] = useState(true);
    const [refresh, setRefresh] = useState(false);

    // Danh sách công ty + ngày chốt + người sửa gần nhất (1 request, không N+1)
    useEffect(() => {
        let mounted = true;
        setDangTai(true);
        Axios.get(URL_LIST_ALL + "chotcong_congty", user.config)
            .then((res) => {
                if (!mounted) return;
                if (res.data.status === "success") {
                    const ds = res.data.data || [];
                    setNgayChotChung(res.data.ngay_chot_chung || 26);
                    setDanhSach(ds);
                    const gt = {};
                    ds.forEach((c) => {
                        gt[c.id] = c.chotcong === null || c.chotcong === undefined ? "" : String(c.chotcong);
                    });
                    setGiaTri(gt);
                }
                setDangTai(false);
            })
            .catch((err) => {
                console.log(err);
                if (mounted) setDangTai(false);
            });
        return () => (mounted = false);
    }, [user, refresh]);

    // Xem toàn bộ lịch sử đổi ngày chốt của một công ty
    const xemLichSu = (congty) => {
        Axios.get(URL_LIST_ALL + "chotcong_lichsu?company_id=" + congty.id, user.config)
            .then((res) => {
                const ds = (res.data && res.data.data) || [];
                confirmAlert({
                    title: "Lịch sử đổi ngày chốt công",
                    message: congty.title,
                    childrenElement: () => (
                        <div style={{ maxHeight: 320, overflowY: "auto", marginTop: 10 }}>
                            {ds.length === 0 ? (
                                <p className="text-muted">Chưa có lần đổi nào được ghi nhận.</p>
                            ) : (
                                <table className="table table-sm" style={{ fontSize: 13 }}>
                                    <thead>
                                        <tr><th>Thời điểm</th><th>Người sửa</th><th>Thay đổi</th></tr>
                                    </thead>
                                    <tbody>
                                        {ds.map((h) => (
                                            <tr key={h.id}>
                                                <td className="text-nowrap">{h.thoi_diem_text}</td>
                                                <td>{h.nguoi_sua || "—"}{h.ma_nguoi_sua ? " (" + h.ma_nguoi_sua + ")" : ""}</td>
                                                <td className="text-nowrap">{h.tu} → <strong>{h.sang}</strong></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    ),
                    buttons: [{ label: "Đóng" }],
                });
            })
            .catch((err) => console.log(err));
    };

    const doiGiaTri = (id, value) => {
        setGiaTri((prev) => ({ ...prev, [id]: value }));
    };

    const luu = (congty) => {
        const raw = (giaTri[congty.id] || "").trim();

        // Để trống = gỡ cài đặt riêng, quay về dùng ngày chốt chung.
        let giaTriGui = null;
        if (raw !== "") {
            const so = parseInt(raw, 10);
            // Chỉ 1..28: ngày 29/30/31 không có ở mọi tháng -> kỳ công sẽ nhảy sai tháng.
            if (isNaN(so) || so < 1 || so > 28) {
                confirmAlert({
                    title: "Giá trị không hợp lệ",
                    message: "Ngày chốt công phải là số từ 1 đến 28. Để trống nếu muốn dùng ngày chốt chung (" + ngayChotChung + ").",
                    buttons: [{ label: "OK" }],
                });
                return;
            }
            giaTriGui = so;
        }

        const tenKy = giaTriGui === null ? ngayChotChung : giaTriGui;
        const batDau = tenKy;
        const ketThuc = tenKy === 1 ? "cuối tháng" : tenKy - 1;

        confirmAlert({
            title: "Xác nhận đổi ngày chốt công",
            message:
                "Kỳ công của " + congty.title + " sẽ là: ngày " + batDau + " tháng trước → ngày " + ketThuc + " tháng này." +
                (giaTriGui === null ? " (dùng ngày chốt chung)" : "") +
                " Thay đổi này ảnh hưởng tới bảng chấm công, công chuẩn, cấp phép và báo cáo của công ty này.",
            buttons: [
                {
                    label: "Đồng ý",
                    onClick: () => {
                        setDangLuu(congty.id);
                        Axios.put(URL_LIST_ALL + "company/" + congty.id, { chotcong: giaTriGui }, user.config)
                            .then((res) => {
                                setDangLuu(null);
                                if (res.data.status === "success") {
                                    setRefresh((r) => !r);
                                    confirmAlert({
                                        title: "Thành công",
                                        message: "Đã cập nhật ngày chốt công cho " + congty.title,
                                        buttons: [{ label: "OK" }],
                                    });
                                } else {
                                    confirmAlert({
                                        title: "Lỗi",
                                        message: res.data.message || "Không cập nhật được",
                                        buttons: [{ label: "OK" }],
                                    });
                                }
                            })
                            .catch((err) => {
                                setDangLuu(null);
                                console.log(err);
                            });
                    },
                },
                { label: "Huỷ" },
            ],
        });
    };

    return (
        <AkkhorLayout idrole="cai-dat-ngay-chot-cong">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>Cài đặt ngày chốt công</li>
                </ul>
            </div>

            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Cài đặt ngày chốt công theo công ty</h3>
                        </div>
                    </div>

                    <div className="alert alert-info" style={{ fontSize: 13 }}>
                        <strong>Cách hoạt động:</strong> để trống ô ngày chốt thì công ty dùng
                        ngày chốt chung (<strong>{ngayChotChung}</strong>) cài ở mục
                        {" "}<Link to="/cai-dat-nhan-su">Cài đặt nhân sự</Link>. Nhập số từ
                        <strong> 1 đến 28</strong> để công ty đó có kỳ công riêng.
                        <br />
                        Ví dụ: ngày chốt <strong>21</strong> nghĩa là kỳ công chạy từ ngày 21 tháng
                        trước đến ngày 20 tháng này.
                    </div>

                    {dangTai ? (
                        <div className="text-center p-4">
                            <Spinner />
                        </div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table display data-table text-nowrap">
                                <thead>
                                    <tr>
                                        <th style={{ width: 60 }}>ID</th>
                                        <th>Công ty</th>
                                        <th style={{ width: 150 }}>Ngày chốt công</th>
                                        <th style={{ width: 250 }}>Kỳ công áp dụng</th>
                                        <th style={{ width: 230 }}>Cập nhật gần nhất</th>
                                        <th style={{ width: 150 }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {danhSach.map((c) => {
                                        const raw = giaTri[c.id];
                                        const dungChung = !raw || raw === "";
                                        const ngay = dungChung ? ngayChotChung : parseInt(raw, 10);
                                        const hopLe = !isNaN(ngay) && ngay >= 1 && ngay <= 28;
                                        const ketThuc = ngay === 1 ? "cuối tháng" : ngay - 1;
                                        return (
                                            <tr key={c.id}>
                                                <td>{c.id}</td>
                                                <td>{c.title}</td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        min="1"
                                                        max="28"
                                                        className="form-control height32"
                                                        placeholder={"Chung (" + ngayChotChung + ")"}
                                                        value={raw === undefined ? "" : raw}
                                                        onChange={(e) => doiGiaTri(c.id, e.target.value)}
                                                    />
                                                </td>
                                                <td>
                                                    {hopLe ? (
                                                        <span className={dungChung ? "text-muted" : "text-primary font-weight-bold"}>
                                                            Ngày {ngay} tháng trước → ngày {ketThuc} tháng này
                                                            {dungChung ? " (mặc định)" : ""}
                                                        </span>
                                                    ) : (
                                                        <span className="text-danger">Phải là số từ 1 đến 28</span>
                                                    )}
                                                </td>
                                                <td style={{ fontSize: 13 }}>
                                                    {c.thoi_diem_sua_text ? (
                                                        <>
                                                            <div><strong>{c.nguoi_sua || "—"}</strong>{c.ma_nguoi_sua ? " (" + c.ma_nguoi_sua + ")" : ""}</div>
                                                            <div className="text-muted">
                                                                {c.thoi_diem_sua_text}
                                                                {c.thay_doi_cuoi ? " · " + c.thay_doi_cuoi : ""}
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <span className="text-muted">Chưa từng chỉnh sửa</span>
                                                    )}
                                                </td>
                                                <td className="text-nowrap">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-primary"
                                                        disabled={dangLuu === c.id}
                                                        onClick={() => luu(c)}
                                                    >
                                                        {dangLuu === c.id ? <Spinner /> : "Lưu"}
                                                    </button>
                                                    {c.thoi_diem_sua_text && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-outline-secondary ml-1"
                                                            title="Xem toàn bộ lịch sử thay đổi"
                                                            onClick={() => xemLichSu(c)}
                                                        >
                                                            Lịch sử
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </AkkhorLayout>
    );
}
